var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58639 6.29416C6.57014 6.29416 6.55931 6.29416 6.54306 6.29416C6.51598 6.28874 6.47806 6.28874 6.44556 6.29416C4.87473 6.24541 3.68848 5.01041 3.68848 3.48833C3.68848 1.93916 4.95056 0.677078 6.49973 0.677078C8.04889 0.677078 9.31098 1.93916 9.31098 3.48833C9.30556 5.01041 8.11389 6.24541 6.60264 6.29416C6.59723 6.29416 6.59181 6.29416 6.58639 6.29416ZM6.49973 1.48958C5.40014 1.48958 4.50098 2.38874 4.50098 3.48833C4.50098 4.57166 5.34598 5.44374 6.42389 5.48166C6.45098 5.47624 6.52681 5.47624 6.59723 5.48166C7.65889 5.43291 8.49306 4.56083 8.49848 3.48833C8.49848 2.38874 7.59931 1.48958 6.49973 1.48958Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59163 12.2146C5.52996 12.2146 4.46288 11.9438 3.65579 11.4021C2.90288 10.9038 2.49121 10.2213 2.49121 9.47917C2.49121 8.73709 2.90288 8.04917 3.65579 7.54542C5.28079 6.46751 7.91329 6.46751 9.52746 7.54542C10.275 8.04376 10.692 8.72625 10.692 9.46834C10.692 10.2104 10.2804 10.8983 9.52746 11.4021C8.71496 11.9438 7.65329 12.2146 6.59163 12.2146ZM4.10538 8.22792C3.58538 8.57459 3.30371 9.01875 3.30371 9.48459C3.30371 9.945 3.59079 10.3892 4.10538 10.7304C5.45413 11.635 7.72913 11.635 9.07788 10.7304C9.59788 10.3838 9.87954 9.93959 9.87954 9.47375C9.87954 9.01334 9.59246 8.56917 9.07788 8.22792C7.72913 7.32875 5.45413 7.32875 4.10538 8.22792Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.39d581749057e53b1f62d785500ff5b2.svg";
export { ForwardRef as ReactComponent };